const actions = {
    GET_INCENTIVE_DATA: 'GET_INCENTIVE_DATA',
    GET_INCENTIVE_DATA_SUCCESS: 'GET_INCENTIVE_DATA_SUCCESS',
    GET_INCENTIVE_DATA_FAILED: 'GET_INCENTIVE_DATA_FAILED',
    GET_VOUCHERS_DATA: 'GET_VOUCHERS_DATA',
    GET_VOUCHERS_DATA_SUCCESS: 'GET_VOUCHERS_DATA_SUCCESS',
    GET_VOUCHERS_DATA_FAILED: 'GET_VOUCHERS_DATA_FAILED',
    INCENTIVE_RESET:'INCENTIVE_RESET',
    DELETE_INCENTIVE: 'DELETE_INCENTIVE',
    DELETE_INCENTIVE_SUCCESS: 'DELETE_INCENTIVE_SUCCESS',
    DELETE_INCENTIVE_FAILED: 'DELETE_INCENTIVE_FAILED',
    INCENTIVE_RESET_MESSAGE:'INCENTIVE_RESET_MESSAGE',
    OPEN_INCENTIVE_FORM: 'OPEN_INCENTIVE_FORM',
    INCENTIVE_RESET:"INCENTIVE_RESET",
    GET_SERVICES: 'GET_SERVICES',
    GET_SERVICES_SUCCESS: 'GET_SERVICES_SUCCESS',
    GET_SERVICES_FAILED: 'GET_SERVICES_FAILED',
    ADD_INCENTIVE: 'ADD_INCENTIVE',
    ADD_INCENTIVE_SUCCESS: 'ADD_INCENTIVE_SUCCESS',
    ADD_INCENTIVE_FAILED: 'ADD_INCENTIVE_FAILED',
    EDIT_INCENTIVE: 'EDIT_INCENTIVE',
    EDIT_INCENTIVE_SUCCESS: 'EDIT_INCENTIVE_SUCCESS',
    EDIT_INCENTIVE_FAILED: 'EDIT_INCENTIVE_FAILED',
    getIncentiveData: (offset, limit, search, fromDate, toDate) => ({
      type: actions.GET_INCENTIVE_DATA,
      payload: { offset, limit, search, fromDate, toDate },
    }),
    getIncentiveDataSuccess: (data,totalData) => ({
      type: actions.GET_INCENTIVE_DATA_SUCCESS,
      payload: { data, totalData },
    }),
    getVouchersData: () => ({
      type: actions.GET_VOUCHERS_DATA,
      payload: {},
    }),
    getVouchersDataSuccess: ( totalVoucher) => ({
      type: actions.GET_VOUCHERS_DATA_SUCCESS,
      payload: { totalVoucher },
    }),
    getVouchersDataFailed: (error) => ({
      type: actions.GET_VOUCHERS_DATA_FAILED,
      payload: { error },
    }),    
    deleteIncentive: (id) => ({
      type: actions.DELETE_INCENTIVE,
      payload: { id },
    }),
    deleteIncentiveSuccess: (message) => ({
      type: actions.DELETE_INCENTIVE_SUCCESS,
      payload: { message },
    }),
    deleteIncentiveFailed: (error) => ({
      type: actions.DELETE_INCENTIVE_FAILED,
      payload: { error },
    }),
    IncentiveResetMessage: () => ({
      type: actions.INCENTIVE_RESET_MESSAGE,
    }),
    openForm: () => ({
      type: actions.OPEN_INCENTIVE_FORM,
    }),
    IncentiveReset: () => ({
      type: actions.INCENTIVE_RESET,
    }),
    getServices: () => ({
      type: actions.GET_SERVICES,
    }),
    getServicesSuccess: (servicelist) => ({
      type: actions.GET_SERVICES_SUCCESS,
      servicelist,
    }),
    getServicesFailed: (error) => ({
      type: actions.GET_SERVICES_FAILED,
      payload: { error },
    }),
    addIncentive: (data) => ({
      type: actions.ADD_INCENTIVE,
      payload: { data },
    }),
    addIncentiveSuccess: (message) => ({
      type: actions.ADD_INCENTIVE_SUCCESS,
      payload: { message },
    }),
    addIncentiveFailed: (error) => ({
      type: actions.ADD_INCENTIVE_FAILED,
      payload: { error },
    }),
    editIncentive: (incentive_id, data) => ({
      type: actions.EDIT_INCENTIVE,
      payload: { incentive_id, data },
    }),
    editIncentiveSuccess: (message) => ({
      type: actions.EDIT_INCENTIVE_SUCCESS,
      payload: { message },
    }),
    editIncentiveFailed: (error) => ({
      type: actions.EDIT_INCENTIVE_FAILED,
      payload: { error },
    }),
  };
  
  export default actions;